<template>
  <div class="flex items-center">
    <label :for="id" class="block w-22 flex-shrink-0 mr-2">
      {{ label }} <span class="text-sm">(m)</span>
    </label>
    <input
      :id="id"
      :name="name"
      type="text"
      :aria-invalid="error"
      :value="value"
      class="block min-w-0 h-11 border px-4 transition-colors duration-200"
      :class="{ 'border-red': error }"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  name: "DimensionInput",

  props: {
    id: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      default: "",
    },

    label: {
      type: String,
      required: true,
    },

    value: {
      type: String,
      required: true,
    },

    error: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
